<template>
  <v-row align="center" justify="center" style="height: 100vh">
    <div class="text-center">
      <v-progress-circular indeterminate color="primary" size="64" />
      <div class="mt-4 grey--text">Completing sign in...</div>
    </div>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AuthCallback",

  async created() {
    try {
      await this.handleAuthentikCallback();
      await this.$router.push("/");
    } catch {
      await this.$router.push("/login");
    }
  },

  methods: {
    ...mapActions("auth/account", ["handleAuthentikCallback"]),
  },
};
</script>
